import { useCallback } from 'react';
import { useFocusEffect } from '@react-navigation/native';
import { useAuthenticationStore } from 'src/domain/stores/useAuthenticationStore';
import { useEventStore } from 'src/domain/stores/useEventStore';
import { resolveAddedOrConfirm } from 'src/presentation/helpers/EventDeeplinkHandler';

/**
 * Handles a remembered event code after the user has logged in.
 */
export function usePendingEventDeeplink(): void {
	useFocusEffect(
		useCallback(() => {
			const { pendingEventCode, setPendingEventCode } = useEventStore.getState();
			if (!pendingEventCode) return;
			if (useAuthenticationStore.getState().isLoggedin !== true) return;

			setPendingEventCode(null);
			let cancelled = false;
			// Sync the account's events first (post-login they are often not local yet), so an event the user already
			// has on their account opens directly instead of prompting to add it again.
			(async () => {
				await useAuthenticationStore.getState().getProfile();
				if (!cancelled) resolveAddedOrConfirm(pendingEventCode);
			})().catch(() => undefined);
			return () => {
				cancelled = true;
			};
		}, []),
	);
}
